// src/components/SuppliersRightPanel.jsx
import React, { useState, useEffect, useMemo } from "react";
import { fetchApprovedSuppliers } from "../lib/suppliers";

const SuppliersRightPanel = ({ categories }) => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await fetchApprovedSuppliers();
        setSuppliers(Array.isArray(data) ? data : []);
      } catch (err) {
        setError("加载供应商列表失败");
        setSuppliers([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const filteredSuppliers = useMemo(() => {
    if (!Array.isArray(suppliers)) return [];
    return suppliers.filter(supplier => {
      const matchesCategory = selectedCategory === "all" || supplier.category === selectedCategory;
      const matchesSearch = supplier.company_name?.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [suppliers, selectedCategory, searchTerm]);

  if (loading) {
    return (
      <div className="space-y-8">
        <div className="bg-white p-6 rounded-4xl shadow-2xl border border-gray-100">
          <p className="text-center text-gray-600">加载中...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-8">
        <div className="bg-white p-6 rounded-4xl shadow-2xl border border-gray-100">
          <p className="text-center text-red-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* 搜索与筛选 */}
      <div className="bg-white p-6 rounded-4xl shadow-2xl border border-gray-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">搜索供应商</label>
            <input
              type="text"
              placeholder="输入供应商名称..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">筛选类别</label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category === "all" ? "所有类别" : category}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="text-center text-gray-600">
          共 <span className="font-bold text-blue-600">{filteredSuppliers.length}</span> 家合格供应商
        </div>
      </div>

      {/* 供应商列表 */}
      <div className="space-y-4">
        {filteredSuppliers.map((supplier) => (
          <div
            key={supplier.id}
            className="bg-white border border-gray-200 rounded-2xl p-5 hover:shadow-md transition-shadow duration-300"
          >
            <div className="flex flex-wrap items-center gap-3">
              <h3 className="text-lg font-bold text-gray-900">{supplier.company_name}</h3>
              <span className="bg-green-600 text-white px-2 py-1 rounded-full text-xs font-bold">已入围</span>
              <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs">
                {supplier.category}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuppliersRightPanel;